/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const WebAppVideoEditorPublishedPlatformEntryDtoPlatformEnum = {
    YOUTUBE: "YOUTUBE",
    TWITTER: "TWITTER",
    INSTAGRAM: "INSTAGRAM",
    DAILYMOTION: "DAILYMOTION",
    FACEBOOK: "FACEBOOK",
    DEMO: "DEMO",
    TIKTOK: "TIKTOK"
} as const;

export type WebAppVideoEditorPublishedPlatformEntryDtoPlatformEnumKey = (typeof WebAppVideoEditorPublishedPlatformEntryDtoPlatformEnum)[keyof typeof WebAppVideoEditorPublishedPlatformEntryDtoPlatformEnum];

export const WebAppVideoEditorPublishedPlatformEntryDtoStatusEnum = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type WebAppVideoEditorPublishedPlatformEntryDtoStatusEnumKey = (typeof WebAppVideoEditorPublishedPlatformEntryDtoStatusEnum)[keyof typeof WebAppVideoEditorPublishedPlatformEntryDtoStatusEnum];

export type WebAppVideoEditorPublishedPlatformEntryDto = {
    /**
     * @description Social platform (e.g. YOUTUBE, TWITTER)
     * @type string
    */
    platform: WebAppVideoEditorPublishedPlatformEntryDtoPlatformEnumKey;
    /**
     * @description Social upload job status (scheduled through terminal states)
     * @type string
    */
    status: WebAppVideoEditorPublishedPlatformEntryDtoStatusEnumKey;
    /**
     * @description Upload entity id from social-export
     * @type string, uuid
    */
    uploadId: string;
};